import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { markOnboardingComplete } from "../api/auth";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { RisographBackground } from "../components/RisographBackground";
import { useAuth } from "../hooks/useAuth";

export function OnboardingCelebrationPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { setOnboardingComplete } = useAuth();

	useEffect(() => {
		setOnboardingComplete(true);
		markOnboardingComplete().catch(() => {});
	}, [setOnboardingComplete]);

	return (
		<div className="relative min-h-screen flex flex-col items-center justify-center px-8 text-center">
			<RisographBackground />
			<div className="max-w-sm w-full animate-fade-in">
				<div className="w-12 h-12 rounded-full mx-auto mb-10 opacity-60 bg-[#3ED8C3]" />
				<p className="font-ui text-[10px] uppercase tracking-[0.25em] text-ink/40 mb-4">
					{t("onboarding.celebration.eyebrow")}
				</p>
				<h1 className="font-display text-5xl font-bold text-ink leading-tight mb-6">
					{t("onboarding.celebration.headline")}
				</h1>
				<p className="font-body italic text-xl text-ink/60 leading-relaxed mb-12">
					{t("onboarding.celebration.body")}
				</p>
				<button
					type="button"
					onClick={() => navigate("/home")}
					className="ink-btn px-10 py-3.5 font-ui text-sm uppercase tracking-widest"
				>
					{t("onboarding.celebration.cta")}
				</button>
			</div>
			<div className="absolute bottom-8">
				<LanguageSwitcher />
			</div>
		</div>
	);
}
